// src/admin/api/adminApi.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000/api";

// Axios instance with JSON headers
const adminApi = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token if present
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ========================
// AUTH
// ========================

// Djoser + SimpleJWT endpoints
export const login = (username, password) =>
  adminApi.post("/auth/jwt/create/", { username, password });

export const getMe = () => adminApi.get("/auth/users/me/");

// ========================
// ARTICLES
// ========================

// NOTE:
// If your DRF ArticleViewSet is still ReadOnly, POST/PATCH/DELETE will fail.
// Change it to ModelViewSet or add mixins for create/update/delete.
//
// Example DRF endpoint assumptions:
// GET    /articles/                   -> list
// POST   /articles/                   -> create
// GET    /articles/<slug>/            -> retrieve
// PATCH  /articles/<slug>/            -> partial update
// DELETE /articles/<id>/              -> delete by ID (or adjust to slug if you coded so)

export const getArticles = (params = {}) =>
  adminApi.get("/articles/", { params });

export const getArticle = (slug) =>
  adminApi.get(`/articles/${slug}/`);

export const createArticle = (payload) =>
  adminApi.post("/articles/", payload);

export const updateArticle = (slug, payload) =>
  adminApi.patch(`/articles/${slug}/`, payload);

export const deleteArticle = (id) =>
  adminApi.delete(`/articles/${id}/`); // adjust if your destroy uses slug instead of id

// ========================
// CATEGORIES
// ========================

export const getCategories = () => adminApi.get("/categories/");

// these will only work if you made CategoryViewSet writable:
export const createCategory = (payload) =>
  adminApi.post("/categories/", payload);

export const updateCategory = (slug, payload) =>
  adminApi.patch(`/categories/${slug}/`, payload);

export const deleteCategory = (id) =>
  adminApi.delete(`/categories/${id}/`);

// ========================
// TAGS
// ========================

export const getTags = () => adminApi.get("/tags/");

export const createTag = (payload) =>
  adminApi.post("/tags/", payload);

export const updateTag = (slug, payload) =>
  adminApi.patch(`/tags/${slug}/`, payload);

export const deleteTag = (id) =>
  adminApi.delete(`/tags/${id}/`);

// ========================
// COMMENTS
// ========================

export const getComments = (params = {}) =>
  adminApi.get("/comments/", { params });

// Approve / update
export const updateComment = (id, payload) =>
  adminApi.patch(`/comments/${id}/`, payload);

export const deleteComment = (id) =>
  adminApi.delete(`/comments/${id}/`);

// ========================
// USERS
// ========================

export const getUsers = () => adminApi.get("/users/");

export default adminApi;
